
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import IconButton from "@/components/UI/IconButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";

@Component({
  components: {
    Dropdown,
    IconButton
  }
})
export default class SearchBoxEmptyState extends Vue {
  @Prop({ default: "element" })
  label!: string;

  clearSearch() {
    this.$emit("input");
  }
}
